import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _mutations, _actions;
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import Vue from 'vue';
import { stringify } from 'qs';
import Cookies from 'js-cookie';
import { sendCaptcha, loginByPhone, requestCookie, getUserInfo, inAppUserInfo, loginByPass, getUserCountryByUid } from '../../api/login';
import { sid } from '../../config';
import { yoda } from '../../utils/yoda';
import { deviceInfo } from '../../utils/env';
var deviceInfoData = deviceInfo();
export var login = 'login';
export var logout = 'logout';
export var queryUserInfo = 'queryUserInfo';
export var sendCaptchaCode = 'sendCaptchaCode';
export var requestZtCookie = 'requestZtCookie';
export var setPhone = 'setPhone';
export var setCountryInfo = 'setCountryInfo';
// 可以监听vuex数据变化
var state = Vue.observable({
  userInfo: {},
  logined: false,
  phone: {
    areaCode: '',
    phoneNum: ''
  },
  countryInfo: {}
});
var loginModule = {
  namespaced: true,
  state: state,
  mutations: (_mutations = {}, _defineProperty(_mutations, queryUserInfo, function (state, payload) {
    Object.assign(state, payload);
  }), _defineProperty(_mutations, setPhone, function (state, payload) {
    localStorage.setItem('recharge_phone', JSON.stringify(payload));
  }), _defineProperty(_mutations, setCountryInfo, function (state, payload) {
    state.countryInfo = payload;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, login, function (_ref, payload) {
    var commit = _ref.commit;
    return payload.smsCode ? loginByPhone(payload) : loginByPass(payload);
  }), _defineProperty(_actions, setPhone, function (_ref2, payload) {
    var commit = _ref2.commit;
    commit(setPhone, payload);
  }), _defineProperty(_actions, "sendCaptchaCode", function sendCaptchaCode(_ref3, payload) {
    var commit = _ref3.commit;
    return sendCaptcha(payload);
  }), _defineProperty(_actions, requestZtCookie, function (_ref4, payload) {
    var commit = _ref4.commit;
    return requestCookie(payload);
  }), _defineProperty(_actions, logout, function () {
    // const loginPagePath = deviceInfoData.isPhone
    //     ? '/kwai/phone-login'
    //     : '/kwai/login';
    var loginPagePath = '/recharge/login';
    var params = {
      sid: sid,
      followUrl: encodeURI("".concat(window.location.origin).concat(loginPagePath))
    };
    window.location.href = "/rest/o/w/user/logout?".concat(stringify(params));
  }), _defineProperty(_actions, queryUserInfo, function (_ref5) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, res, userId, ud, data, countryRes;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref5.commit;
              _context.prev = 1;
              if (!state.logined) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              res = {
                user: {}
              };
              userId = ''; // 执行端内逻辑
              if (!deviceInfoData.isInApp) {
                _context.next = 21;
                break;
              }
              if (deviceInfoData.isLogin) {
                _context.next = 13;
                break;
              }
              _context.next = 10;
              return yoda.ready();
            case 10:
              yoda.component.login();
              _context.next = 19;
              break;
            case 13:
              ud = Cookies.get('ud');
              _context.next = 16;
              return inAppUserInfo({
                userId: ud
              });
            case 16:
              data = _context.sent;
              userId = ud;
              res = {
                user: data.userProfile.profile,
                result: data.result
              };
            case 19:
              _context.next = 26;
              break;
            case 21:
              _context.next = 23;
              return getUserInfo();
            case 23:
              res = _context.sent;
              userId = res.user.user_id;
              // cookie中的userId被设置成了httpOnly导致无法获取，新创建一个以供端外调用thirdchannel组件中的encryptParams接口时能获取到userId
              Cookies.set('recharge_uid', userId);
            case 26:
              commit(queryUserInfo, {
                logined: res.result === 1,
                userInfo: res.result === 1 ? res.user : {}
              });
              _context.next = 29;
              return getUserCountryByUid({
                inApp: deviceInfoData.isInApp
              })({
                userId: userId
              });
            case 29:
              countryRes = _context.sent;
              commit(setCountryInfo, countryRes.data);
              _context.next = 36;
              break;
            case 33:
              _context.prev = 33;
              _context.t0 = _context["catch"](1);
              commit(queryUserInfo, {
                logined: false
              });
            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 33]]);
    }))();
  }), _actions)
};
export default loginModule;